import { InputConverterFunc } from '../../inputConverter';

export interface IUserSettingsConfiguration {
    name: string;
    label: string;
    type: UserSettingsType;
    isSelect?: boolean;
    items?: IUserSettingItem[];
}

export interface IUserSettingItem {
    name: string;
    label: string;
    value: any;
}

export interface IUserSettingQuery {
    query: string;
    orderBy: string;
}

export default class UserSettingsConfiguration implements IUserSettingsConfiguration {
    constructor(obj?: IUserSettingsConfiguration) {
        Object.assign(this, obj);

        if (!this.type) {
            throw new Error('type is invalid');
        }
    }

    name = '';
    label = '';
    type: UserSettingsType = 'check-list';
    isSelect?: boolean;
    query = null;
    items: IUserSettingItem[];
}

export let UserSettingsConfigurationConverter: InputConverterFunc<UserSettingsConfiguration> = (value: any) => {
    if (typeof value === 'string') { return new UserSettingsConfiguration(<IUserSettingsConfiguration>JSON.parse(value)); }
    if (typeof value === 'object') { return new UserSettingsConfiguration(<IUserSettingsConfiguration>value); }
    return value;
};

export let UserSettingsConfigurationArrayConverter: InputConverterFunc<UserSettingsConfiguration[]> = (value: any) => {
    if (typeof value === 'string') { return (<IUserSettingsConfiguration[]>JSON.parse(value)).map(c => new UserSettingsConfiguration(c)); }
    if (typeof value === 'object') { return (<IUserSettingsConfiguration[]>value.map(c => new UserSettingsConfiguration(c))); }
    return value;
};

export type UserSettingsType = 'districts' | 'counties' | 'check-list' | 'extent';
